import AccountBankService from "./AccountBankService";

export const accountBankService = new AccountBankService();